import { PLAN_TYPE, PlanType } from "@/constants";
import { FeatureType } from "@/features";

export type FrontendGrowthPlan = {
  accent?: string; // color

  type: PlanType;
  name: string;
  price_string: string;
  price_extra: string;
  cta: string;
  feature_title?: string;
  features: Array<{
    required_feature?: FeatureType;
    name: string;
  }>;
};

export const basic: FrontendGrowthPlan = {
  accent: "var(--pink-900)",
  type: PLAN_TYPE.US_BASIC,
  name: L.GROWTH_BASIC_PLAN_NAME, // "Professional"
  price_string: L.GROWTH_BASIC_PLAN_PRICE,
  price_extra: L.GROWTH_BASIC_PLAN_PRICE_EXTRA,
  cta: L.GROWTH_BASIC_PLAN_CTA,
  feature_title: L.GROWTH_BASIC_PLAN_FEATURE_LIST_TITLE,
  features: [
    {
      name: L.GROWTH_BASIC_PLAN_FEATURE_1,
    },
    {
      name: L.GROWTH_BASIC_PLAN_FEATURE_2,
    },
    {
      name: L.GROWTH_BASIC_PLAN_FEATURE_3,
    },
    {
      name: L.GROWTH_BASIC_PLAN_FEATURE_4,
    },
    {
      name: L.GROWTH_BASIC_PLAN_FEATURE_5,
    },
  ],
};

export const custom1: FrontendGrowthPlan = {
  accent: "var(--blue-700)",
  type: PLAN_TYPE.CUSTOM,
  name: L.GROWTH_CUSTOM_1_PLAN_NAME, // "Team"
  price_string: L.GROWTH_CUSTOM_1_PLAN_PRICE,
  price_extra: L.GROWTH_CUSTOM_1_PLAN_PRICE_EXTRA,
  cta: L.GROWTH_CUSTOM_1_PLAN_CTA,
  feature_title: L.GROWTH_CUSTOM_1_PLAN_FEATURE_LIST_TITLE,
  features: [
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_1,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_2,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_3,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_4,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_5,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_6,
    },
    {
      name: L.GROWTH_CUSTOM_1_PLAN_FEATURE_7,
    },
  ],
};

export const custom2: FrontendGrowthPlan = {
  accent: "var(--blue-700)",
  type: PLAN_TYPE.CUSTOM,
  name: L.GROWTH_CUSTOM_2_PLAN_NAME, // "Enterprise"
  price_string: L.GROWTH_CUSTOM_2_PLAN_PRICE,
  price_extra: L.GROWTH_CUSTOM_2_PLAN_PRICE_EXTRA,
  cta: L.GROWTH_CUSTOM_2_PLAN_CTA,
  feature_title: L.GROWTH_CUSTOM_2_PLAN_FEATURE_LIST_TITLE,
  features: [
    {
      name: L.GROWTH_CUSTOM_2_PLAN_FEATURE_1,
    },
    {
      name: L.GROWTH_CUSTOM_2_PLAN_FEATURE_2,
    },
  ],
};
